import { SET_FILTERS } from "../actions";

export default function filter(state = [], action) {
  switch (action.type) {
    case SET_FILTERS:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/filters.js